(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('announcement-coupon')) {
    class AnnouncementCoupon extends HTMLElement {
      connectedCallback() {
        if (this.button) return;
        this.button = this.querySelector('button');
        this.label = this.querySelector('[data-coupon-label]');
        this.status = this.querySelector('[role="status"]');
        this.button.addEventListener('click', () => this.copy());
      }

      disconnectedCallback() {
        clearTimeout(this.resetTimer);
        if (this.label) this.label.textContent = this.dataset.code;
      }

      fallbackCopy() {
        const field = document.createElement('textarea');
        field.value = this.dataset.code;
        field.readOnly = true;
        field.style.cssText = 'position:fixed;opacity:0;pointer-events:none';
        document.body.append(field);
        field.select();
        let copied = false;
        try { copied = document.execCommand('copy'); } catch (_) {}
        field.remove();
        this.button.focus({ preventScroll: true });
        return copied;
      }

      async copy() {
        clearTimeout(this.resetTimer);
        this.status.textContent = '';
        let copied = false;
        if (navigator.clipboard?.writeText) {
          try {
            await navigator.clipboard.writeText(this.dataset.code);
            copied = true;
          } catch (_) {}
        }
        if (!copied) copied = this.fallbackCopy();
        this.status.textContent = copied ? this.dataset.copied : this.dataset.error;
        if (copied) {
          this.label.textContent = this.dataset.copied;
          this.resetTimer = setTimeout(() => { this.label.textContent = this.dataset.code; }, 2000);
        }
      }
    }
    customElements.define('announcement-coupon', AnnouncementCoupon);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["configurable-products"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('linea-product-favorite')) {
  customElements.define('linea-product-favorite', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      if (!this.button || this.bound) return;
      this.bound = true;
      this.sync = () => {
        let ids = [];
        try { ids = JSON.parse(localStorage.getItem('linea-product-favorites') || '[]'); } catch {}
        const active = Array.isArray(ids) && ids.includes(this.dataset.productId);
        this.button.setAttribute('aria-pressed', String(active));
        this.button.setAttribute('aria-label', active ? this.dataset.removeLabel : this.dataset.addLabel);
      };
      this.button.addEventListener('click', () => {
        let ids = [];
        try { ids = JSON.parse(localStorage.getItem('linea-product-favorites') || '[]'); } catch {}
        if (!Array.isArray(ids)) ids = [];
        const id = this.dataset.productId;
        ids = ids.includes(id) ? ids.filter(value => value !== id) : [...ids, id];
        try { localStorage.setItem('linea-product-favorites', JSON.stringify(ids)); }
        catch { return; }
        window.dispatchEvent(new Event('linea-favorites-updated'));
      });
      window.addEventListener('linea-favorites-updated', this.sync);
      window.addEventListener('storage', this.sync);
      this.sync();
    }
    disconnectedCallback() {
      window.removeEventListener('linea-favorites-updated', this.sync);
      window.removeEventListener('storage', this.sync);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-curated-products"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('linea-product-favorite')) {
  customElements.define('linea-product-favorite', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      if (!this.button || this.bound) return;
      this.bound = true;
      this.sync = () => {
        let ids = [];
        try { ids = JSON.parse(localStorage.getItem('linea-product-favorites') || '[]'); } catch {}
        const active = Array.isArray(ids) && ids.includes(this.dataset.productId);
        this.button.setAttribute('aria-pressed', String(active));
        this.button.setAttribute('aria-label', active ? this.dataset.removeLabel : this.dataset.addLabel);
      };
      this.button.addEventListener('click', () => {
        let ids = [];
        try { ids = JSON.parse(localStorage.getItem('linea-product-favorites') || '[]'); } catch {}
        if (!Array.isArray(ids)) ids = [];
        const id = this.dataset.productId;
        ids = ids.includes(id) ? ids.filter(value => value !== id) : [...ids, id];
        try { localStorage.setItem('linea-product-favorites', JSON.stringify(ids)); }
        catch { return; }
        window.dispatchEvent(new Event('linea-favorites-updated'));
      });
      window.addEventListener('linea-favorites-updated', this.sync);
      window.addEventListener('storage', this.sync);
      this.sync();
    }
    disconnectedCallback() {
      window.removeEventListener('linea-favorites-updated', this.sync);
      window.removeEventListener('storage', this.sync);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-blocks-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('linea-product-favorite')) {
  customElements.define('linea-product-favorite', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      if (!this.button || this.bound) return;
      this.bound = true;
      this.sync = () => {
        let ids = [];
        try { ids = JSON.parse(localStorage.getItem('linea-product-favorites') || '[]'); } catch {}
        const active = Array.isArray(ids) && ids.includes(this.dataset.productId);
        this.button.setAttribute('aria-pressed', String(active));
        this.button.setAttribute('aria-label', active ? this.dataset.removeLabel : this.dataset.addLabel);
      };
      this.button.addEventListener('click', () => {
        let ids = [];
        try { ids = JSON.parse(localStorage.getItem('linea-product-favorites') || '[]'); } catch {}
        if (!Array.isArray(ids)) ids = [];
        const id = this.dataset.productId;
        ids = ids.includes(id) ? ids.filter(value => value !== id) : [...ids, id];
        try { localStorage.setItem('linea-product-favorites', JSON.stringify(ids)); }
        catch { return; }
        window.dispatchEvent(new Event('linea-favorites-updated'));
      });
      window.addEventListener('linea-favorites-updated', this.sync);
      window.addEventListener('storage', this.sync);
      this.sync();
    }
    disconnectedCallback() {
      window.removeEventListener('linea-favorites-updated', this.sync);
      window.removeEventListener('storage', this.sync);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
